export const SEND_MAIL_SUCCESS = 'SEND_MAIL_SUCCESS';
export const PASSWORD_CHANGED = 'PASSWORD_CHANGED';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const ERROR = 'ERROR';
export const ERROR_LINK = 'ERROR_LINK';
export const ERROR_SUBSCRIBE = 'ERROR_SUBSCRIBE';
export const RESET = 'RESET';


// WEBPACK FOOTER //
// ./src/components/ResetPassword/resetPasswordActionTypes.js